import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgCellRendererComponent } from '../../../../global/gx-ag-grid/ag-cell-renderer.component';
import { LinkCellLocalStoreService } from './link-cell-local-store.service';
import { LSCField } from '../../../../../models/LSCFields';
import { sendToGoogleAnalytics } from '../../../../../core/utilities';
import { PrependProtocolPipe } from '../../../../../pipes/prepend-protocol.pipe';
import { SplitStringPipe } from '../../../../../pipes/split-string.pipe';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgClass } from '@angular/common';
import { LetDirective } from '@ngrx/component';

export enum LinkCellSubtype {
  SINGLE_LINK,
  MULTIPLE_LINKS
}

@Component({
    selector: 'app-link-cell',
    templateUrl: './link-cell.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LinkCellLocalStoreService],
    standalone: true,
    imports: [LetDirective, NgClass, NgxSkeletonLoaderModule, SplitStringPipe, PrependProtocolPipe]
})
export class LinkCellComponent extends AgCellRendererComponent {

  linkCellSubtype = LinkCellSubtype;
  viewModel$ = this.localStore.viewModel$;
  constructor(protected localStore: LinkCellLocalStoreService) {
    super(localStore);
  }

  /**
   * Track event in Google Analytics
   */
  trackLinkClick(fieldName: LSCField): void {
    sendToGoogleAnalytics('open link', 'Navigation', ('Open ' + fieldName),
    );
  }

}
